import { EVENT_VISIBILITY_MEMBERS_ONLY } from '@/services/platform/data/events/types';

/** `visibility` code that flags a members-only event (from `EventConstants`). */
export const MEMBERS_ONLY = EVENT_VISIBILITY_MEMBERS_ONLY;

export function isMembersOnly(visibility?: string | null): boolean {
  return visibility === MEMBERS_ONLY;
}
